import { render, staticRenderFns } from "./Misconduct.vue?vue&type=template&id=5f1163ca&"
import script from "./Misconduct.vue?vue&type=script&lang=js&"
export * from "./Misconduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports